import script from "./TutorialView.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialView.vue?vue&type=script&setup=true&lang=js"

import "./TutorialView.vue?vue&type=style&index=0&id=33b475ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b475ba"]])

export default __exports__